import HomePage from './pages/HomePage.vue';
import MaterialPage from './pages/MaterialPage.vue';


export default [
    { path: '/', component: HomePage },
    { name: "Material", path: '/materials/:material?', component: MaterialPage }
];